// extracted by mini-css-extract-plugin
module.exports =  {"component":"_2787e5dfdf--component--ZRXJY","time":"_2787e5dfdf--time--n2VnG","info":"_2787e5dfdf--info--R5_H_"};